/* Analyze team for stats, etc */

export function getTeamHpRating(teamCombatantModels=[]) {
  const currentTeamHp = teamCombatantModels.map(c => c.hp || 0).reduce((a,b) => a+b);
  const currentTeamMaxHp = teamCombatantModels.map(c => c.maxHp || 0).reduce((a,b) => a+b);

  return Math.round( ( currentTeamHp / currentTeamMaxHp) * 100 );
  //100 = All Full //0 = All Empty
}

export function getTeamStatusRating(teamCombatantModels=[]) {
  const statusMap = {
    "normal": 50,

    //Negative statuses
    "lag": 0,
    "fire": 0,
    "memory-leak": 0,

    //Positive statuses
    "focus": 100,
    "fury": 100,
    "deadline": 100,
  };

  //Default to 50 if status string is unknown
  const aliveCombatants = teamCombatantModels.filter(c => c.hp > 0);
  const statusTotalRating = aliveCombatants.map(c => {

    if (statusMap[c.status] === "undefined") {
      console.warn('NO STATUS VALUE DEFINED IN `getTeamStatusRating`:', c.status)
      return 50;
    }
    return statusMap[c.status];

  }).reduce((a,b) => a+b);

  return Math.round( statusTotalRating / aliveCombatants.length )
}


/** Take in a list of combatants and only return ones who have a HP percentage less than or equal to the `thresholdPercent` */
//EX: get the critical people on my team, or on the enemy team
export function getCriticalHpCombatants(thresholdPercent=0, combatantModels=[], userOptions={}) {
  const options = {
    sortHpLowToHigh: true, //sort with lowest first
    ...userOptions
  };
  return combatantModels.filter(combModel => {
    const percent = combModel.hp / combModel.maxHp * 100;
    return percent <= thresholdPercent
  }).sort((a,b) => {
    //Sort order option
    if (options.sortHpLowToHigh) {
      return a.hp >= b.hp ? 1 : -1
    } else {
      return a.hp < b.hp ? 1 : -1
    }
  });
}


/** Return the ALIVE combatants that have any of these statuses */
export function getCombatantsWithStatus(combatantModels=[], statusNames=[]) {
  return combatantModels.filter(combModel => {
    return statusNames.indexOf(combModel.status) > -1 && combModel.isAlive();
  });
}


// WEBPACK FOOTER //
// ./src/battle/analysis/team-analysis-utilities.js